<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only">
    <div >
<div style="text-align:left;float:right">
        <fs1-span class="label">Estados:</fs1-span>
        <ul class="statusFilter mt_10">
          <li
            v-for="(item, i) in status_names"
            :key="i"
            :class="model.find(i => i === item) && `selected`"
            :style="model.find(i => i === item) &&`background-color:${dona_colors[i]}`"
            @click="toggleItems(model, item)">
            {{item}}
          </li>
        </ul>
</div>


    </div>
  </pre_input>
</template>
<script>
import filter_rq from './filter_rq';
import pre_input_js from '@/components/mixins/pre_input';
export default {
  props:{
    f_key:{},
  },
  mixins: [ filter_rq, pre_input_js ],
  data(){
    return {
      model: [],
      multiple: true,
      reset_on_value_change:true,
      filter_rq_type:['>'],
      status_names:['In Progress', 'Not Commenced', 'Completed'],
    }
  },
  computed: {
    dona_colors(){ return this.dark_t?['#d99148', '#e4b43e', '#4d752f']:['#d99148', '#aaaaaa', '#454444'] },
    k_f(){ return this.f_key || `ae__status` },
    c_value_key() {return this.value_key || this.item_key},
  },
  created(){
    this.model = [...this.status_names];
  },
  methods: {
    toggleItems(items, item) {
      items.find(i => i === item) ? items.splice(items.indexOf(item), 1) : items.push(item);
      this.upd();
    },
    set_model() { this.model = this.value || [] },
    upd(){
      this.$emit('update:value', this.model);
      const ex_f = {};
      ex_f[this.k_f] = this.model;
      this.pre_get(ex_f,this.k_f);
      this.get_rq(ex_f);
    },
    then_get_rows(r) { return r },
  },
};
</script>
<style scoped>
  .label {
    color:grey;
  }
  .statusFilter{
    list-style: none;
    padding: 0;
  }
  .statusFilter > li{
    text-decoration: line-through;
    cursor: pointer;
    border-radius: 3px;
    background-color: none;
    color: black;
    display: inline;
    padding: 4px 14px 4px 14px;
    margin-right: 5px;
  }
  .statusFilter > li.selected{
    color: white;
    text-decoration: none;
  }
  .statusFilter > li.selected.InProgress{ background-color: #d99148; }
  .statusFilter > li.selected.NotCommenced{ background-color: #aaaaaa; }
  .statusFilter > li.selected.Completed{ background-color: #454444; }
</style>